import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-documents-tree-node',
  templateUrl: './documents-tree-node.component.html'
})
export class DocumentsTreeNodeComponent {
  @Input() folder: any;
  @Input() isJobMatchFolders: boolean;
  @Input() isAvailableDocuments: boolean;
  @Input() query: string;

  @Output() selectFolder = new EventEmitter<{ folder: any, type: string }>();
  @Output() addFolder = new EventEmitter<any>();
  @Output() editFolder = new EventEmitter<any>();
  @Output() deleteFolder = new EventEmitter<any>();
  @Output() moveFolder = new EventEmitter<any>();
  @Output() selectFolderWithDocuments = new EventEmitter<any>();
  @Output() selectAndDeselectDocument = new EventEmitter<{ document: any, folder: any }>();
  @Output() documentSelect = new EventEmitter<{ document: any, folder: any }>();

  collapsed = false;

  toggle() {
    this.collapsed = !this.collapsed;
  }

  visible(item: any): boolean {
    return !(this.query && this.query.length > 0 && item.title.indexOf(this.query) === -1);
  }

  onFolderClick() {
    this.selectFolder.emit({ folder: this.folder, type: 'fromFolderSelect' });
  }

  onDocumentClick(document: any) {
    if (!this.isAvailableDocuments) {
      this.documentSelect.emit({ document, folder: this.folder });
    }
  }
}
